import { fetchChannel, fetchCalendarEvents } from "@/api/moimAPI";
import { CALENDAR_CHANNEL_ID } from "@/constant/group";
import { useChannelQuery, useMutationChannels } from "@/queries/channels";
import { CalendarBlock } from "@moim/blockit";
import React from "react";
import CalendarComponent from "./components";

const CalendarContainer = () => {
  const [isLoading, setLoadStatus] = React.useState<boolean>(false);
  const { channels } = useChannelQuery();
  const { storeChannel } = useMutationChannels();
  const channel = channels[
    CALENDAR_CHANNEL_ID
  ] as Moim.Channel.IViewSimpleChannel;

  const calendarBlock = React.useMemo(() => {
    const firstBlock = channel?.view.blocks[0] as Moim.Blockit.V2.BlockType;
    if (firstBlock?.type === "calendar" && firstBlock?.version === "2.0") {
      return firstBlock as Moim.Blockit.V2.ICalendarBlock;
    }
    return;
  }, [channel]);

  React.useEffect(() => {
    if (!isLoading && !channel) {
      setLoadStatus(true);
      fetchChannel({ channelId: CALENDAR_CHANNEL_ID })
        .then(channelDatum => {
          storeChannel(
            channelDatum as unknown as Moim.Channel.IViewSimpleChannel,
          );
        })
        .finally(() => setLoadStatus(false));
    }
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!channel || !calendarBlock) {
    return <div>캘린더 블록이 없습니다.</div>;
  }

  return (
    <CalendarBlock.Contexts.Calender.CalendarContextProvider
      calendarMode={calendarBlock.displayCalendarType}
      initSelectedDateValue={calendarBlock.pivotDate}
    >
      <CalendarBlock.Contexts.Event.CalendarEventProvider
        fetchEvents={fetchCalendarEvents}
      >
        <CalendarComponent {...calendarBlock} />
      </CalendarBlock.Contexts.Event.CalendarEventProvider>
    </CalendarBlock.Contexts.Calender.CalendarContextProvider>
  );
};

export default CalendarContainer;
